import { Theme } from "../../data/style/Theme";
import { AllCenteredColumn } from "../../data/style/Style";
import CircularProgress from "@mui/material/CircularProgress";

const Loader = (props) => {
  let { height, minHeight, dark } = props;
  return (
    <AllCenteredColumn width={"100%"} minHeight={minHeight} height={height}>
      <CircularProgress
        sx={{ color: dark ? "#3E3C3C" : Theme.palette.orange }}
      />
    </AllCenteredColumn>
  );
};

export default Loader;
